function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { orgProjectListKeys } from '@repo/query-keys/organization';
import { navigationItemsKeys } from '@repo/query-keys/user';
import { axios } from '@repo/http';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { get_app_navigation_items, get_org_navigation_items, get_proj_navigation_items, post_pin_navigation_item, post_unpin_navigation_item } from 'ze-api-contract/user-v2/navigation-items';
import { userPinsQuery } from './user-pins';
export const navigationItemsQuery = {
    organizationList: (queryParams)=>({
            queryKey: navigationItemsKeys.organizationList(queryParams).queryKey,
            queryFn: async ()=>{
                return axios.get(get_org_navigation_items(), {
                    params: queryParams
                }).then((res)=>res.data.entities);
            }
        }),
    projectList: (organization, queryParams)=>({
            queryKey: navigationItemsKeys.projectList(organization, queryParams).queryKey,
            queryFn: async ()=>{
                if (!organization) {
                    return null;
                }
                return axios.get(get_proj_navigation_items({
                    organization
                }), {
                    params: queryParams
                }).then((res)=>res.data.entities);
            },
            enabled: Boolean(organization)
        }),
    applicationList: (organization, project, queryParams)=>({
            queryKey: navigationItemsKeys.applicationList(organization, project, queryParams).queryKey,
            queryFn: async ()=>{
                if (!organization || !project) {
                    return null;
                }
                return axios.get(get_app_navigation_items({
                    organization,
                    project
                }), {
                    params: queryParams
                }).then((res)=>res.data.entities);
            },
            enabled: Boolean(organization) && Boolean(project)
        })
};
export const useNavigationOrgItemList = (queryParams)=>{
    const { data: organizationList, isLoading, error } = useQuery(navigationItemsQuery.organizationList(queryParams));
    return {
        organizationList,
        isLoading,
        error
    };
};
export const useNavigationProjItemList = (organization, queryParams)=>{
    const { data: projectList, isLoading, error } = useQuery(navigationItemsQuery.projectList(organization, queryParams));
    return {
        projectList,
        isLoading,
        error
    };
};
export const useNavigationAppItemList = (organization, project, queryParams)=>{
    const { data: applicationList, isLoading, error } = useQuery(navigationItemsQuery.applicationList(organization, project, queryParams));
    return {
        applicationList,
        isLoading,
        error
    };
};
export function usePinItem(projectListParams) {
    const queryClient = useQueryClient();
    const { queryKey: breadcrumbsQueryKey } = userPinsQuery.myPinList;
    return useMutation({
        mutationFn: async (value)=>{
            var _value_type;
            const { type } = value;
            const reqBody = {
                type,
                id: (_value_type = value[type]) === null || _value_type === void 0 ? void 0 : _value_type.id
            };
            await axios.post(post_pin_navigation_item(), reqBody);
            return value;
        },
        onMutate: async (value)=>{
            var _ref, _ref1, _ref2;
            var _value_organization, _value_organization1, _value_project, _value_organization2, _value_project1, _value_application;
            const queryOrganizationKey = navigationItemsQuery.organizationList({
                name: (_value_organization = value.organization) === null || _value_organization === void 0 ? void 0 : _value_organization.queryNameParam
            });
            const queryProjectKey = navigationItemsQuery.projectList((_ref = (_value_organization1 = value.organization) === null || _value_organization1 === void 0 ? void 0 : _value_organization1.name) !== null && _ref !== void 0 ? _ref : '', {
                name: (_value_project = value.project) === null || _value_project === void 0 ? void 0 : _value_project.queryNameParam
            });
            const queryAppKey = navigationItemsQuery.applicationList((_ref1 = (_value_organization2 = value.organization) === null || _value_organization2 === void 0 ? void 0 : _value_organization2.name) !== null && _ref1 !== void 0 ? _ref1 : '', (_ref2 = (_value_project1 = value.project) === null || _value_project1 === void 0 ? void 0 : _value_project1.name) !== null && _ref2 !== void 0 ? _ref2 : '', {
                name: (_value_application = value.application) === null || _value_application === void 0 ? void 0 : _value_application.queryNameParam
            });
            const queryKey = value.type === 'organization' ? queryOrganizationKey.queryKey : value.type === 'project' ? queryProjectKey.queryKey : queryAppKey.queryKey;
            await queryClient.cancelQueries({
                queryKey
            });
            const navigationItems = queryClient.getQueryData(queryKey);
            const updatedNavigationItems = navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.map((item)=>{
                var _value_value_type;
                if (item.id === ((_value_value_type = value[value.type]) === null || _value_value_type === void 0 ? void 0 : _value_value_type.id)) {
                    return _object_spread_props(_object_spread({}, item), {
                        isPinned: true
                    });
                }
                return item;
            });
            queryClient.setQueryData(queryKey, updatedNavigationItems);
        },
        onSettled: async (data)=>{
            var _ref, _ref1, _ref2;
            var _data_organization, _data_organization1, _data_project, _data_organization2, _data_project1, _data_application, _data_organization3;
            if (!data) {
                return;
            }
            const queryOrganizationKey = navigationItemsQuery.organizationList({
                name: (_data_organization = data.organization) === null || _data_organization === void 0 ? void 0 : _data_organization.queryNameParam
            });
            const queryProjectKey = navigationItemsQuery.projectList((_ref = (_data_organization1 = data.organization) === null || _data_organization1 === void 0 ? void 0 : _data_organization1.name) !== null && _ref !== void 0 ? _ref : '', {
                name: (_data_project = data.project) === null || _data_project === void 0 ? void 0 : _data_project.queryNameParam
            });
            const queryAppKey = navigationItemsQuery.applicationList((_ref1 = (_data_organization2 = data.organization) === null || _data_organization2 === void 0 ? void 0 : _data_organization2.name) !== null && _ref1 !== void 0 ? _ref1 : '', (_ref2 = (_data_project1 = data.project) === null || _data_project1 === void 0 ? void 0 : _data_project1.name) !== null && _ref2 !== void 0 ? _ref2 : '', {
                name: (_data_application = data.application) === null || _data_application === void 0 ? void 0 : _data_application.queryNameParam
            });
            const queryKey = data.type === 'organization' ? queryOrganizationKey.queryKey : data.type === 'project' ? queryProjectKey.queryKey : queryAppKey.queryKey;
            const { queryKey: projectListQueryKey } = orgProjectListKeys.projectList({
                organization: (_data_organization3 = data.organization) === null || _data_organization3 === void 0 ? void 0 : _data_organization3.name,
                queryParams: projectListParams !== null && projectListParams !== void 0 ? projectListParams : {}
            });
            await queryClient.invalidateQueries({
                queryKey
            });
            await queryClient.invalidateQueries({
                queryKey: projectListQueryKey
            });
            await queryClient.invalidateQueries({
                queryKey: breadcrumbsQueryKey
            });
        }
    });
}
export function useUnPinItem(projectListParams) {
    const queryClient = useQueryClient();
    const { queryKey: breadcrumbsQueryKey } = userPinsQuery.myPinList;
    return useMutation({
        mutationFn: async (value)=>{
            var _value_type;
            const { type } = value;
            const reqBody = {
                type,
                id: (_value_type = value[type]) === null || _value_type === void 0 ? void 0 : _value_type.id
            };
            await axios.post(post_unpin_navigation_item(), reqBody);
            return value;
        },
        onMutate: async (value)=>{
            var _ref, _ref1, _ref2;
            var _value_organization, _value_organization1, _value_project, _value_organization2, _value_project1, _value_application;
            const queryOrganizationKey = navigationItemsQuery.organizationList({
                name: (_value_organization = value.organization) === null || _value_organization === void 0 ? void 0 : _value_organization.queryNameParam
            });
            const queryProjectKey = navigationItemsQuery.projectList((_ref = (_value_organization1 = value.organization) === null || _value_organization1 === void 0 ? void 0 : _value_organization1.name) !== null && _ref !== void 0 ? _ref : '', {
                name: (_value_project = value.project) === null || _value_project === void 0 ? void 0 : _value_project.queryNameParam
            });
            const queryAppKey = navigationItemsQuery.applicationList((_ref1 = (_value_organization2 = value.organization) === null || _value_organization2 === void 0 ? void 0 : _value_organization2.name) !== null && _ref1 !== void 0 ? _ref1 : '', (_ref2 = (_value_project1 = value.project) === null || _value_project1 === void 0 ? void 0 : _value_project1.name) !== null && _ref2 !== void 0 ? _ref2 : '', {
                name: (_value_application = value.application) === null || _value_application === void 0 ? void 0 : _value_application.queryNameParam
            });
            const queryKey = value.type === 'organization' ? queryOrganizationKey.queryKey : value.type === 'project' ? queryProjectKey.queryKey : queryAppKey.queryKey;
            await queryClient.cancelQueries({
                queryKey
            });
            const navigationItems = queryClient.getQueryData(queryKey);
            const updatedNavigationItems = navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.map((item)=>{
                var _value_value_type;
                if (item.id === ((_value_value_type = value[value.type]) === null || _value_value_type === void 0 ? void 0 : _value_value_type.id)) {
                    return _object_spread_props(_object_spread({}, item), {
                        isPinned: false
                    });
                }
                return item;
            });
            queryClient.setQueryData(queryKey, updatedNavigationItems);
        },
        onSettled: async (data)=>{
            var _ref, _ref1, _ref2;
            var _data_organization, _data_organization1, _data_project, _data_organization2, _data_project1, _data_application, _data_organization3;
            if (!data) {
                return;
            }
            const queryOrganizationKey = navigationItemsQuery.organizationList({
                name: (_data_organization = data.organization) === null || _data_organization === void 0 ? void 0 : _data_organization.queryNameParam
            });
            const queryProjectKey = navigationItemsQuery.projectList((_ref = (_data_organization1 = data.organization) === null || _data_organization1 === void 0 ? void 0 : _data_organization1.name) !== null && _ref !== void 0 ? _ref : '', {
                name: (_data_project = data.project) === null || _data_project === void 0 ? void 0 : _data_project.queryNameParam
            });
            const queryAppKey = navigationItemsQuery.applicationList((_ref1 = (_data_organization2 = data.organization) === null || _data_organization2 === void 0 ? void 0 : _data_organization2.name) !== null && _ref1 !== void 0 ? _ref1 : '', (_ref2 = (_data_project1 = data.project) === null || _data_project1 === void 0 ? void 0 : _data_project1.name) !== null && _ref2 !== void 0 ? _ref2 : '', {
                name: (_data_application = data.application) === null || _data_application === void 0 ? void 0 : _data_application.queryNameParam
            });
            const queryKey = data.type === 'organization' ? queryOrganizationKey.queryKey : data.type === 'project' ? queryProjectKey.queryKey : queryAppKey.queryKey;
            const { queryKey: projectListQueryKey } = orgProjectListKeys.projectList({
                organization: (_data_organization3 = data.organization) === null || _data_organization3 === void 0 ? void 0 : _data_organization3.name,
                queryParams: projectListParams !== null && projectListParams !== void 0 ? projectListParams : {}
            });
            await queryClient.invalidateQueries({
                queryKey
            });
            await queryClient.invalidateQueries({
                queryKey: projectListQueryKey
            });
            await queryClient.invalidateQueries({
                queryKey: breadcrumbsQueryKey
            });
        }
    });
}
